import { render, staticRenderFns } from "./QuickReview.vue?vue&type=template&id=56f25168&"
import script from "./QuickReview.vue?vue&type=script&lang=js&"
export * from "./QuickReview.vue?vue&type=script&lang=js&"
import style0 from "./QuickReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f25168')) {
      api.createRecord('56f25168', component.options)
    } else {
      api.reload('56f25168', component.options)
    }
    module.hot.accept("./QuickReview.vue?vue&type=template&id=56f25168&", function () {
      api.rerender('56f25168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/QuickReview.vue"
export default component.exports